const groupPrefix = 'segments'

export const apiProductsSegments = {
	fetchSegments: async () => {
		const { data } = await apiCommon<IProductSegment[]>(`${groupPrefix}`, { method: 'GET', skipSSRPayload: true })
		const response = data.map((item) => {
			return ProductSegment(item)
		})
		return response
	},

	fetchSegment: async (SegmentID: number) => {
		const { data } = await apiCommon<IProductSegment>(`${groupPrefix}/${SegmentID}`, { method: 'GET' })
		return ProductSegment(data)
	},

	addSegment: async (productSegmentData: Partial<IProductSegmentModel>) => {
		const { data } = await apiCommon<IProductSegment>(`${groupPrefix}`, {
			method: 'POST',
			body: productSegmentToJSON(productSegmentData),
		})
		return ProductSegment(data)
	},

	updateSegment: async (productSegmentData: Partial<IProductSegmentModel>) => {
		const { data } = await apiCommon<IProductSegment>(`${groupPrefix}/${productSegmentData.id}`, {
			method: 'PUT',
			body: productSegmentToJSON(productSegmentData),
		})
		return ProductSegment(data)
	},

	deleteSegment: async (productSegmentID: string) => {
		const data = await apiCommon<string>(`${groupPrefix}/${productSegmentID}`, { method: 'DELETE' })
		return data
	},

	addGroupToSegment: async (segmentID: number, groups: number[]) => {
		const { data } = await apiCommon<IProductSegment>(`${groupPrefix}/${segmentID}/groups`, {
			method: 'POST',
			body: { groups },
		})
		return ProductSegment(data)
	},
}
